import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getAuditLogs, getAuditPresence } from "../../services/api";
import { secretKey } from "../../services/config";
import EncryptDecrypt from "../../utils/encrypt&decrypt";

const namespace = "audit";

export const fetchAuditLogs = createAsyncThunk(
    `${namespace}/fetchAuditLogs`,
    async (params = {}, { rejectWithValue }) => {
        try {
            const data = await getAuditLogs(params);
            return JSON.parse(EncryptDecrypt.decryptdata(data.data.datas, secretKey));
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);

export const fetchAuditPresence = createAsyncThunk(
    `${namespace}/fetchAuditPresence`,
    async (_, { rejectWithValue }) => {
        try {
            const data = await getAuditPresence();
            return JSON.parse(EncryptDecrypt.decryptdata(data.data.datas, secretKey));
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);

const auditSlice = createSlice({
    name: namespace,
    initialState: {
        logsData: { count: 0, rows: [] },
        logsLoading: false,
        logsError: false,
        presenceData: { admin: [], staff: [], mobile: [], portal: [], photo: [] },
        presenceLoading: false,
        presenceError: false,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchAuditLogs.pending, (state) => {
                state.logsLoading = true;
                state.logsError = false;
                state.logsData = { count: 0, rows: [] };
            })
            .addCase(fetchAuditLogs.fulfilled, (state, action) => {
                state.logsLoading = false;
                state.logsData = action.payload;
            })
            .addCase(fetchAuditLogs.rejected, (state) => {
                state.logsLoading = false;
                state.logsError = true;
            })
            .addCase(fetchAuditPresence.pending, (state) => {
                state.presenceLoading = true;
                state.presenceError = false;
            })
            .addCase(fetchAuditPresence.fulfilled, (state, action) => {
                state.presenceLoading = false;
                state.presenceData = action.payload.presence || state.presenceData;
            })
            .addCase(fetchAuditPresence.rejected, (state) => {
                state.presenceLoading = false;
                state.presenceError = true;
            });
    },
});

export default auditSlice.reducer;
